import { CohortEnum } from '@eigtech/auth0-types'
import { startCase } from 'lodash-es'

const cohortDict: Partial<Record<CohortEnum, string>> = {
  csr: 'Coordinator',
  super: 'Super User',
}

export const getCohortLabel = (cohort: CohortEnum) => cohortDict[cohort] || startCase(cohort)
